<template>
  <v-dialog :value="true" hide-overlay persistent width="300">
    <v-card color="primary" dark>
      <v-card-text>
        <slot name="loading-text">Chargement...</slot>
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  setup() {
    return {};
  },
});
</script>
